import { callApiWithAuthorization } from "../CallApi";

export async function getSubscriptions() {
    const response = await callApiWithAuthorization("/api/v0/subscriptions");
    const data = await response.json();
    return data;
}

export async function getSubscription(id) {
    const response = await callApiWithAuthorization("/api/v0/subscription/" + id);
    const data = await response.json();
    return data;
}

export async function updateSubscription(id, subscription) {
    const response = await callApiWithAuthorization("/api/v0/subscription/" + id, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(subscription),
    });
    return response;
}

export async function createSubscription(subscription) {
    const response = await callApiWithAuthorization("/api/v0/subscription", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(subscription),
    });
    return response;
}

export async function assignSubscriptionToUser(organizationId, userId) {
    let request = await callApiWithAuthorization("/api/v0/assignSubscription", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            organizationId: organizationId,
            userId: userId
        })
    })
    let response = await request.json()
    return response
}

export async function removeSubscriptionFromUser(organizationId, userId) {
    await callApiWithAuthorization("/api/v0/removeSubscription", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            organizationId: organizationId,
            userId: userId
        })
    })
}

export async function getSubscriptionAndProjects(organizationId) {
    let request = await callApiWithAuthorization("/api/v0/getSubscriptionAndProjects/" + organizationId)
    let response = await request.json()
    return response
}